import { Button, ButtonProps } from "PFComponents/button";
import { LoadingDots } from "PFComponents/loading_dots";
import React from "react";

type CreateButtonProps = {
  label: string;
  isLoading: boolean;
  disabled: boolean;
  qaId?: string;
} & Pick<ButtonProps, "kind">;

export const CreateButton = ({ label, isLoading, kind, disabled, qaId }: CreateButtonProps) => (
  <Button form="booking_form" type="submit" disabled={disabled} kind={kind} aria-label={label} qaId={qaId}>
    {isLoading ? <LoadingDots /> : label}
  </Button>
);
